module.exports = __webpack_public_path__ + "static/img/hkj4.bf1cccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/hkj4.jpg
// module id = O0nR
// module chunks = 0